const STYLE_BLOCK = `
<style id="wsng-lollipop-style">
  :root, html, body {
    margin: 0;
    padding: 0;
    width: 100% !important;
    max-width: 100% !important;
    background: transparent;
    font-family: 'Inter', 'Segoe UI', system-ui, -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif;
    color: #0f172a;
  }

  body.wsng-lollipop-body {
    padding: 0;
    margin: 0;
    background: transparent;
    box-sizing: border-box;
    overflow: hidden;
  }

  .wsng-lollipop-root {
    position: relative !important;
    width: 100% !important;
    max-width: 100% !important;
    height: 100% !important;
    background: transparent;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
    border: none;
    box-sizing: border-box;
    overflow: hidden;
  }

  .wsng-lollipop-root .modebar,
  .wsng-lollipop-root .modebar-group {
    background: transparent !important;
    box-shadow: none !important;
  }

  .wsng-lollipop-root .modebar-btn {
    color: rgba(15, 23, 42, 0.55) !important;
    opacity: 0.65;
    transition: opacity 0.18s ease;
  }

  .wsng-lollipop-root .modebar-btn:hover {
    opacity: 1;
  }

  .wsng-lollipop-root .modebar-btn[data-title*="Download"],
  .wsng-lollipop-root .modebar-btn[data-title*="download"],
  .wsng-lollipop-root .modebar-btn[data-title*="Save"],
  .wsng-lollipop-root .modebar-btn[data-title*="save"] {
    display: none !important;
  }

  .wsng-lollipop-root [data-title="Download plot as a png"],
  .wsng-lollipop-root [data-title="Download plot as a svg"] {
    display: none !important;
  }

  .wsng-lollipop-root .modebar {
    top: clamp(10px, 2vw, 16px) !important;
    right: clamp(10px, 3vw, 22px) !important;
  }

  .wsng-lollipop-root svg,
  .wsng-lollipop-root .js-plotly-plot,
  .wsng-lollipop-root .plotly {
    width: 100% !important;
    height: 100% !important;
    max-width: 100% !important;
    max-height: 100% !important;
  }

  .wsng-lollipop-root .plot-container {
    width: 100% !important;
    height: 100% !important;
  }

  #wsng-lollipop-toolbar {
    position: absolute;
    top: 1.5vh;
    right: 1.5vh;
    display: inline-flex;
    align-items: center;
    gap: 0.8vh;
    z-index: 40;
  }

  .wsng-lollipop-btn {
    appearance: none;
    border: 1px solid rgba(15, 23, 42, 0.15);
    border-radius: 5.6vh;
    padding: 1.8vh 2.4vh;
    font-size: 1.8vh;
    font-weight: 500;
    letter-spacing: 0.02em;
    background: rgba(15, 23, 42, 0.08);
    color: rgba(15, 23, 42, 0.9);
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);
    transition: all 0.2s ease;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }

  .wsng-lollipop-btn:hover {
    background: rgba(15, 23, 42, 0.12);
    border-color: rgba(15, 23, 42, 0.25);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.2);
  }

  .wsng-lollipop-btn:focus-visible {
    outline: 2px solid rgba(15, 23, 42, 0.3);
    outline-offset: 2px;
  }

  .wsng-lollipop-btn:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.15);
  }

  .wsng-lollipop-btn .wsng-dot {
    display: inline-block;
    width: 0.5vh;
    height: 0.5vh;
    border-radius: 50%;
    margin-right: 0.5vh;
    background: rgba(15, 23, 42, 0.7);
  }

  .wsng-lollipop-caption {
    margin-top: 18px;
    font-size: 13px;
    color: rgba(71, 85, 105, 0.82);
    text-align: right;
  }
</style>
`;

const SCRIPT_BLOCK = `
<script id="wsng-lollipop-script">
(function () {
  const schedule = (fn) => window.requestAnimationFrame(fn);

  const sanitiseButtons = (doc) => {
    const candidates = doc.querySelectorAll('button, a');
    candidates.forEach((btn) => {
      const text = (btn.textContent || '').trim().toLowerCase();
      if (!text) return;
      if (text.includes('save as svg') || text.includes('save as png')) {
        btn.remove();
      }
    });
  };

  const hideModebarSave = (root) => {
    const modebar = root.querySelector('.modebar');
    if (!modebar) return;
    Array.from(modebar.querySelectorAll('.modebar-btn')).forEach((btn) => {
      const title = (btn.getAttribute('data-title') || '').toLowerCase();
      if (title.includes('download plot as') || title.includes('save as')) {
        btn.remove();
      }
    });
    if (!modebar.querySelector('.modebar-btn')) {
      modebar.style.display = 'none';
    }
  };

  const ensureToolbar = (root, doc) => {
    if (!root || doc.getElementById('wsng-lollipop-toolbar')) return;

    const toolbar = doc.createElement('div');
    toolbar.id = 'wsng-lollipop-toolbar';

    const createBtn = (format, label) => {
      const btn = doc.createElement('button');
      btn.className = 'wsng-lollipop-btn';
      btn.dataset.format = format;
      const dot = doc.createElement('span');
      dot.className = 'wsng-dot';
      btn.appendChild(dot);
      btn.appendChild(doc.createTextNode(label));
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const plotly = doc.defaultView && doc.defaultView.Plotly;
        if (!plotly || !plotly.downloadImage) return;

        const graphNode = root.classList.contains('js-plotly-plot') ? root : root.querySelector('.js-plotly-plot') || root;
        const rect = graphNode.getBoundingClientRect();
        const filename = (doc.title || 'lollipop-plot').toLowerCase().replace(/\\s+/g, '-');

        plotly.downloadImage(graphNode, {
          format,
          filename,
          width: Math.max(900, Math.round(rect.width || 1060)),
          height: Math.max(540, Math.round(rect.height || 600))
        }).catch(() => {});
      });
      return btn;
    };

    toolbar.appendChild(createBtn('png', 'Download PNG'));
    toolbar.appendChild(createBtn('svg', 'Download SVG'));

    root.appendChild(toolbar);
  };

  const enhance = () => {
    const doc = document;
    if (!doc || !doc.body) return;

    doc.body.classList.add('wsng-lollipop-body');

    const root =
      doc.querySelector('.js-plotly-plot') ||
      doc.querySelector('.clinvar-lollipop') ||
      doc.querySelector('.html-widget') ||
      doc.body.firstElementChild;

    if (!root) return;

    root.classList.add('wsng-lollipop-root');
    if (window.getComputedStyle(root).position === 'static') {
      root.style.position = 'relative';
    }

    hideModebarSave(root);
    sanitiseButtons(doc);
    ensureToolbar(root, doc);
  };

  const kickoff = () => schedule(enhance);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kickoff, { once: true });
  } else {
    kickoff();
  }

  const observer = new MutationObserver(() => {
    enhance();
    if (document.getElementById('wsng-lollipop-toolbar')) {
      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
</script>
`;

export const enhanceLollipopHtml = (htmlString) => {
  if (!htmlString) return htmlString;

  let enhanced = htmlString;

  if (!/wsng-lollipop-style/.test(enhanced)) {
    if (enhanced.includes('</head>')) {
      enhanced = enhanced.replace('</head>', `${STYLE_BLOCK}</head>`);
    } else {
      enhanced = `${STYLE_BLOCK}${enhanced}`;
    }
  }

  if (!/wsng-lollipop-script/.test(enhanced)) {
    if (enhanced.includes('</body>')) {
      enhanced = enhanced.replace('</body>', `${SCRIPT_BLOCK}</body>`);
    } else {
      enhanced = `${enhanced}${SCRIPT_BLOCK}`;
    }
  }

  return enhanced;
};
